export const formatQueryString = (value: string): string =>
  value.toLocaleLowerCase().replace(/\s|-/g, '')
